import { UserInfo } from "@/types/User";

export default function getDefaultRoute(userInfo: Pick<UserInfo, "isAdmin" | "hasNeverBeenMember">): string {
  return userInfo.isAdmin && userInfo.hasNeverBeenMember ? "/admin/" : "/dogs/";
}
